// extracted by mini-css-extract-plugin
export var actionButton = "_s7-0";
export var actionMenuContainer = "_s7-i";
export var bubble = "_s7-2";
export var bubbleActionMenu = "_s7-j";
export var bubbleContext = "_s7-6";
export var bubbleItems = "_s7-7";
export var customer = "_s7-3";
export var divider = "_s7-8";
export var fileList = "_s7-9";
export var hiddenComment = "_s7-o";
export var infoAbove = "_s7-a";
export var internal = "_s7-4";
export var lightActionButton = "_s7-1";
export var link = "_s7-b";
export var merchant = "_s7-5";
export var message = "_s7-c";
export var profilePicture = "_s7-e";
export var quillToolbarContainer = "_s7-f";
export var senderDate = "_s7-g";
export var senderDateCustomer = "_s7-h";
export var senderName = "_s7-d";
export var time = "_s7-k";
export var uploadedImage = "_s7-l";
export var username = "_s7-m";
export var xsmall = "_s7-n";